import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class CreateHotelMarkup {
  static buildRequest(pMarkpObj) {
    let returnValue = null;
    try {
      let body = {
        stayfrom: pMarkpObj.from,
        stayto: pMarkpObj.to,
        pricingType: pMarkpObj.valueType.code,
        markupValue: pMarkpObj.amount,
        currency: pMarkpObj.valueType.value==1?pMarkpObj.currency.code:null,
        // currency: null,
        applicableDays:pMarkpObj.applicableDays,
        hotelId: pMarkpObj.hotel.hotelid,
        roomId: pMarkpObj.room.roomid,
        supplierGroupId: pMarkpObj.supplier.id
      };

      returnValue = body;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_CREATE_HOTEL_MARKUP,
        "error in building body for CreateHotelMarkup ",
        err.toString(),
        "buildRequest",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }

  static async getResponse(pReqOptions) {
    let returnValue = null;
    try {
      returnValue = await HttpPost.makeHttpPostRequest(
        SERVICE_URL.API_CREATE_HOTEL_MARKUP,
        pReqOptions
      );
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_CREATE_HOTEL_MARKUP,
        "error in getting Response from  CreateHotelMarkup ",
        err.toString(),
        "getResponse",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }
}
